import { HttpService } from "@/core/services/http.service";
export class CloseProjectService {
  static useAddCloseApi() {
    const api = (data: { closeReasonType: string; projectCloseReason: string ; projectId: string; remark: string}) =>
      HttpService.axios({
        method: "POST",
        url: `/project/add_close`,
        data,
      });
    return HttpService.useRequest<any>(api);
  }
  
  static useCloseProjectReasonApi() {
    const api = (projectId) =>
      HttpService.axios({
        method: "GET",
        url: `/project/project_close_reason_type/${projectId}`,
      });
    return HttpService.useRequest<{closeReasonType:string,projectId:string}>(api);
  }
}
